import * as actionType from '../action-type';

export const updateCarpetBasicReport = (data) => ({
  type: actionType.UPDATE_CARPET_BASIC_REPORT,
  payload: data,
});

export const resetCarpetBasicReport = () => ({
  type: actionType.RESET_CARPET_BASIC_REPORT,
});
